/**
 * @generated SignedSource<<022ae572fe079cb167c3d37f775431c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueProgressBar_versionProgress_IssuesProgressBar$data = {
  readonly doneIssuesRedesignTemp: {
    readonly totalCount: number;
  };
  readonly inProgressIssuesRedesignTemp: {
    readonly totalCount: number;
  };
  readonly todoIssuesRedesignTemp: {
    readonly totalCount: number;
  };
  readonly " $fragmentType": "issueProgressBar_versionProgress_IssuesProgressBar";
};
export type issueProgressBar_versionProgress_IssuesProgressBar$key = {
  readonly " $data"?: issueProgressBar_versionProgress_IssuesProgressBar$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueProgressBar_versionProgress_IssuesProgressBar">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "totalCount"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueProgressBar_versionProgress_IssuesProgressBar",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": "doneIssuesRedesignTemp",
        "args": [
          {
            "kind": "Literal",
            "name": "filters",
            "value": {
              "statusCategories": [
                "DONE"
              ]
            }
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "doneIssuesRedesignTemp.totalCount"
          }
        ],
        "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
      },
      "action": "THROW",
      "path": "doneIssuesRedesignTemp"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "inProgressIssuesRedesignTemp",
        "args": [
          {
            "kind": "Literal",
            "name": "filters",
            "value": {
              "statusCategories": [
                "IN_PROGRESS"
              ]
            }
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "inProgressIssuesRedesignTemp.totalCount"
          }
        ],
        "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
      },
      "action": "THROW",
      "path": "inProgressIssuesRedesignTemp"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "todoIssuesRedesignTemp",
        "args": [
          {
            "kind": "Literal",
            "name": "filters",
            "value": {
              "statusCategories": [
                "TODO"
              ]
            }
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "todoIssuesRedesignTemp.totalCount"
          }
        ],
        "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
      },
      "action": "THROW",
      "path": "todoIssuesRedesignTemp"
    }
  ],
  "type": "JiraVersion"
};
})();

(node as any).hash = "9d79a458e2fb5db8bb37fec8334b2eed";

export default node;
